
export enum HomeWidgets {
    TEMP = 0,
    HOME_DEVELOPMENT = 1,
    HOME_NOTIFICATIONS = 2,
    HOME_DEVELOPMENT_LEARNINGPATHS = 3,
    HOME_TASKS = 4,
    HOME_TALENT_FORUM = 5,
    HOME_COMPLIANCE = 6,
    HOME_GOALS = 7,
    HOME_RECRUITMENT = 8,
    HOME_DEVELOPMENT_COURSES_ACTIVE = 9,
    HOME_DEVELOPMENT_COURSES_REQUESTS = 10,
    HOME_DEVELOPMENT_COURSES_FINISHED = 11,
    HOME_CONVERSATIONS = 12,
    HOME_CONVERSATIONS_FORMAL = 13,
    HOME_CONVERSATIONS_INFORMAL = 14,
    HOME_CONVERSATIONS_INFORMAL_PEER = 15,
    HOME_CONVERSATIONS_INFORMAL_ADHOC = 16,
    HOME_CAREER = 17,
    HOME_DEVELOPMENT_COURSES_SPOTLIGHT = 18,
    HOME_GOALS_PERFORMANCE = 19,
    HOME_GOALS_DEVELOPMENT = 20,
    HOME_RECRUITMENT_APPLICATIONS = 21,
    HOME_RECRUITMENT_OPEN = 22,
    HOME_RECRUITMENT_MANAGE = 23,
    HOME_KNOWLEDGE_DOMAINS = 24,
    HOME_MY_SKILLS = 25,
    HOME_MY_OVERVIEW = 26
}
